module.exports = __webpack_public_path__ + "static/media/studio-1.ae0150c0.jpg";